<template>
  <div style="margin-right: 10px; margin-left: 10px; height: 800px" v-if="isMobile.isMobile">
    <div class="accordion" v-if="projectData.length">
      <draggable
        :list="projectData"
        class="list-group"
        handle=".thisDrag"
        ghost-class="ghost"
        :move="checkMove"
        @start.native="dragging = true"
        @end.native="onEnd"
        animation="100"
        :forceFallback="true"
      >
        <div
          v-for="(panel, index) in projectData"
          :key="index"
          style="width: 100%;box-shadow:0 2px 4px -1px rgba(0, 0, 0, 0.01), 0 4px 5px 0 rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(0, 0, 0, 0.08);
          margin: 5px 0;border-radius: 4px;"
  
        >
          <div class="projectText thisDrag" @click.stop="toggle(panel,index)"  @touchstart.prevent="toggle(panel,index)">
            <span class="projectTextTitle">
              {{ projectName }} {{ index + 1 }} {{ panel.name }}</span
            >
            <span style="float:right; display:inline-block; height: 40px; line-height: 40px;"><i class="material-icons" style=" height: 40px; line-height: 40px;">{{ panel.active ? 'expand_less' : 'expand_more' }}</i></span>
            <div v-if="activePanels == index" style="width: 30%; float: right; text-align: right">
              <v-btn
                v-hasPermi="['dev::project::edit']"
                class="btnEdit"
                icon
                small
                @touch="handleProjectChange('edit', panel.name)"
                @click.stop="handleProjectChange('edit', panel.name)"
              >
                <span class="material-icons" style="font-size: 18px">edit</span>
              </v-btn>

              <v-btn
                v-hasPermi="['dev::project::remove']"
                class="btnProjectDel"
                icon
                small
                @touch="handleProjectRemove(panel.name, index)"
                @click="handleProjectRemove(panel.name, index)"
              >
                <span class="material-icons" style="font-size: 18px">delete_forever</span>
              </v-btn>
            </div>
            
          </div>

          <div v-if="panel.active"  style="padding: 10px 0;background-color: #fff;">
            <div v-for="item in taskList" :key="item._id" class="content__wrap">
              <div class="courseNameWrap">
                <p class="courseName">{{ item.name }}</p>
                <v-btn
                  v-if="course.hasAuthModify"
                  v-hasPermi="['dev::task::remove']"
                  class="btnFlow"
                  icon
                  color="error"
                  small
                  @touch="handleDelete(item)"
                  @click.native="handleDelete(item)"
                >
                  <span class="material-icons" style="font-size: 18px">delete_forever</span>
                </v-btn>
                <v-btn
                  v-if="course.hasAuthModify"
                  v-hasPermi="['dev::task::edit']"
                  class="btnFlow"
                  icon
                  color="success"
                  small
                  @touch="checkedTask(item)"
                  @click.native="checkedTask(item)"
                >
                  <span class="material-icons" style="font-size: 18px">edit</span>
                  <!-- <md-tooltip md-direction="top">任务信息修改</md-tooltip> -->
                </v-btn>
                <v-btn
                  v-if="course.hasAuthModify"
                  v-hasPermi="['dev::task::copy']"
                  class="btnFlow"
                  icon
                  color="success"
                  small
                  @touch="copyTask(item)"
                  @click.native="copyTask(item)"
                >
                  <span class="material-icons" style="font-size: 16px">content_copy</span>
                </v-btn>
                <v-btn class="btnFlow" icon color="success" small @click.native="flowEdit(item)" @touch="flowEdit(item)">
                  <span class="material-icons" style="font-size: 16px; color: #4caf50">share</span>
                </v-btn>
              </div>
            </div>
            <div v-if="taskList.length<=0" class="courseNameWrap" style="text-align: center;">
              
            </div> 

            <div
          v-if="taskTotal > 0"
          style="text-align: right"
          class="paginationWrapWrap"
        >
          <div class="paginationWrap">
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              :startPage="false"
              :endPage="false"
            ></pagination>
          </div>

          <v-btn
            v-hasPermi="['dev::task:add']"
            v-if="taskAddBtn || course.hasAuthModify"
            class="btnTaskAdd"
            color="success"
            small
            @touch="showTaskInfo"
            @click.stop="showTaskInfo"
            >新增</v-btn
          >
        </div>
          </div>
        </div>
      </draggable>
    </div>
    <p v-else>没有可显示的面板。</p>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import draggable from 'vuedraggable';
import { mapGetters, mapState } from 'vuex';
import { updateProjectSort } from '@/api/course';
import Swal from 'sweetalert2';
export default {
  components: {
    Pagination,
    draggable,
  },
  props: {
    projectData: {
      default: [],
      type: Array,
    },
  },
  computed: {
    ...mapGetters([
      'showMenu',
      'showEditor',
      'courseList',
      'isMobile',

      'project',
      'course',
      'currentProjectIndex',
      'showMenu',
      'taskList',
    ]),
    projectName() {
      let str = '';
      if (this.course.sectionType == 'xm') {
        str = '项目';
      } else if (this.course.sectionType == 'zj') {
        str = '章节';
      } else if (this.course.sectionType == 'qj') {
        str = '情境';
      } else {
        str = '章节';
      }
      return str;
    },
    taskTotal() {
      this.pagination.total = this.$store.state.task.taskTotal;
      return this.$store.state.task.taskTotal;
    },

    preName() {
      return this.course.childType === 'chapter' ? '章节' : '任务';
    },
  },
  watch: {
    course: {
      handler(news) {
        if (news && news.children.length > 0) {
          this.taskAddBtn = true;
        } else {
          this.taskAddBtn = false;
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      itemisCheck: 'list-group-itemisCheck',
      listgroupitem: 'list-group-item',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15, 25],
        total: 0,
        queryName: '',
      },
      activePanels: null, // 对于非手风琴模式，使用数组来存储
      panels: [
        { title: '面板 1', content: '这是第一个面板的内容。' },
        { title: '面板 2', content: '这是第二个面板的内容。' },
        // 更多面板...
      ],
    };
  },
  methods: {
    toggle(item,index) {
      // this.projectData[index].active = !this.projectData[index].active;
      this.projectData.forEach((panel, i) => {
        if (i !== index) {
          this.$set(panel, 'active', false);
        }
      }); // 然后切换当前面板的状态
      this.$set(this.projectData[index], 'active', !this.projectData[index].active);
      if(item.active){
        this.checkProject(item._id)
      }
    
    },

    checkMove: function (e) {
      // window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    async onEnd(data) {
      let arr = [];
      this.projectData.forEach((item, index) => {
        let obj = {
          _id: item._id,
          orderNum: index + 1,
        };
        arr.push(obj);
      });
      let params = {
        arr,
      };
      await updateProjectSort(params).then(res => {
        console.log(res);
      });
    },
    async handleProjectChange(status) {
      setTimeout(() => {
        this.$store.dispatch('courseAndProject/reverseShowProjectEdit', status);
      }, 100);
    },
    async handleProjectRemove(name, index) {
      let result = await Swal.fire({
        title: '提示',
        text: `确认删除 ${this.projectName + (index + 1)}【${name}】?`,
        type: 'error',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('courseAndProject/removeProject', this.callBackQueryProject);
      }
    },
    changepanels(e) {
      console.log(e);
      this.checkProject(e._id);
    },
    async checkProject(id) {
      this.project_id = id;
      const project = this.course.children.find(item => item._id === this.project_id);
      this.$store.dispatch('courseAndProject/updateProjectData', Object.assign({}, project));
      this.$store.dispatch('editor/closeEditor');
      this.projectListArray &&
        this.projectListArray.forEach(element => {
          if (id == element._id) {
            this.$set(element, 'isCheck', true);
          } else {
            this.$set(element, 'isCheck', false);
          }
        });
    },

    convertTime(time) {
      if (!time) return '';
      const reg = time.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):\d{2}/);
      return `${reg[1]} ${reg[2]}`;
    },
    flowEdit(task) {
      // this.$store.dispatch("task/setTaskInfo", Object.assign({}, task));
      // this.$store.dispatch("editorDefinition/loadData", task.taskEditor);
      // this.$store.dispatch("editorType/loadData", task.project);
      // this.$router.push({
      //   path: "/taskFlow/" + task._id,
      // });
      let url = `${process.env.VUE_APP_TASK_FLOW_URL}/#/${task._id}?tab=${
        this.course.hasAuthModify
      }&token=${localStorage.getItem('token')}`;
      window.open(url, '_blank');
    },
    showSceneList() {
      this.$store.dispatch('editor/reverseDrawerStatus', true);
    },
    checkedTask(task) {
      this.$store.dispatch('task/setTaskInfo', Object.assign({}, task));
      this.$store.dispatch('task/reverseShowTaskEdit', true);
    },
    async copyTask(task) {
      let result = await Swal.fire({
        title: '复制信息',
        text: `${task.name} 确定要复制该任务?,请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        this.$store.dispatch('task/copyTask', Object.assign({}, task));
      }
    },
    showTaskInfo() {
      this.$store.dispatch('task/reverseShowTaskAdd', true);
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        cancelButtonText: '取 消',
        confirmButtonText: '确 定',
        buttonsStyling: false,
        reverseButtons: true, //反转按钮位置
      });

      if (result.value) {
        this.$store.dispatch('task/removeTask', item);
        let pageNum = null;
        let totalPage = Math.ceil((this.pagination.total - 1) / this.pagination.perPage);
        let currengpage =
          this.pagination.currentPage > totalPage ? totalPage : this.pagination.currentPage;
        pageNum = JSON.parse(JSON.stringify(currengpage < 1 ? 1 : currengpage));
        setTimeout(() => {
          this.pagination.currentPage = pageNum;
        }, 500);
      }
    },
  },
  created() {
    this.projectData.forEach(item => {
      item.active = false;
    });
    this.pagination.total = this.taskTotal;
    // taskPagination
    let _this = this;
    this.$EventBus.$off('taskPagination');
    this.$EventBus.$on('taskPagination', function (data) {
      if (window.localStorage.getItem('taskPagination')) {
        let taskPagination = JSON.parse(window.localStorage.getItem('taskPagination'));
        setTimeout(() => {
          _this.pagination.perPage = taskPagination.perPage;
          _this.pagination.currentPage = taskPagination.currentPage;
        }, 800);
      }
    });
    this.$EventBus.$off('getpageSize');
    this.$EventBus.$on('getpageSize', function (data) {
      data(_this.pagination);
    });
  },
  mounted() {},
  destroyed() {
    this.$EventBus.$off('taskPagination');
    this.$EventBus.$off('getpageSize');
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  /* 
  .v-expansion-panel-content {
    display: none; 
  }

  .v-expansion-panel--active .v-expansion-panel-content {
    display: block; 
  }

  .v-expansion-panel--active {
    background-color: #efefef !important; 
    overflow: hidden;
    border-radius: 0px;

  } */
.content__wrap{
  margin: 5px 0;
}
  .courseNameWrap {
    /* background-color: #d2d2d2; */
    border-radius: 5px;
    padding: 0 5px;
    margin: 0 5px;
    
  }
  .courseName {
    margin-bottom: 0px;
    line-height: 26px;
    font-size: 13px;
    width: 180px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  /* .v-expansion-panel-header {
    padding: 16px 14px;
    font-size: 14px !important;
  }

  .v-expansion-panel--active >>> .content__wrap .v-expansion-panel-content__wrap {
    padding: 0 14px 16px;
  } */

  .btnFlow {
    float: right;
    height: 25px;
    width: 24px;
  }
  .paginationWrap {
    text-align: right;
    overflow: hidden;
    width: auto;
    height: auto;
  }
  .pagination-no-border {
    padding-left: 0px !important;
  }
  .btnTaskAdd {
    float: right;
  }
  .paginationWrapWrap {
    padding: 0px 10px !important;
    display: flex;
    justify-content:space-between;
    align-items: center;
    height: 40px;
    line-height: 40px;
  }
  /* .v-expansion-panel{
    margin:10px 0;
  }
  .v-expansion-panel::after{
    border: none !important;
  } */
}

/* .list-group .list-group-item {
  cursor: pointer;
  position: relative;
  display: block;
  padding: 5px 10px;
  margin-bottom: -1px;
  background-color: #fff;
  border-radius: 2px;
  margin: 5px 0;
}

.list-group-itemisCheck {
  cursor: pointer;
  position: relative;
  display: block;
  padding: 5px 10px;
  margin-bottom: -1px;
  background-color: #f3ecff;
  border-radius: 2px;
  margin: 5px 0;
} */

.projectText {
  height: 40px;
  line-height: 40px;
  width: 100% !important;
  padding:0 5px;
}
.projectTextTitle {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 65% !important;
  vertical-align: middle;
  float: left;

  /*   overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
   width: 60% !important; */
}
</style>